import type { NPCModelRegistry } from './types';
import { gameOfThronesNPCs } from './gameOfThrones';
import { wonderlandNPCs } from './wonderland';
import { nightmareChristmasNPCs } from './nightmareChristmas';
// Themed NPCs
import { strangerThingsNPCs } from './themed/strangerThings';
import { jurassicParkNPCs } from './themed/jurassicPark';
import { lordOfTheRingsNPCs } from './themed/lordOfTheRings';
// Adventure-specific NPCs
import { reveilEducatriceNPCs } from './reveilEducatrice';
// Animal NPCs
import { jungleAnimals } from './animals/jungle';
import { desertAnimals } from './animals/desert';
import { mountainAnimals } from './animals/mountain';
import { oceanAnimals } from './animals/ocean';
import { iceAnimals } from './animals/ice';
import { swampAnimals } from './animals/swamp';

// Re-export types
export type { NPCModelProps, NPCModelComponent, NPCModelRegistry } from './types';

// Combine all NPC model registries
export const npcModelRegistry: NPCModelRegistry = {
  ...gameOfThronesNPCs,
  ...wonderlandNPCs,
  ...nightmareChristmasNPCs,
  // Themed
  ...strangerThingsNPCs,
  ...jurassicParkNPCs,
  ...lordOfTheRingsNPCs,
  // Adventure-specific
  ...reveilEducatriceNPCs,
  // Animals
  ...jungleAnimals,
  ...desertAnimals,
  ...mountainAnimals,
  ...oceanAnimals,
  ...iceAnimals,
  ...swampAnimals,
};

// Helper to get an NPC model component by type
export function getNPCModelComponent(npcType: string) {
  return npcModelRegistry[npcType] || null;
}
